<template>
  <div class="container-fluid py-4">

    <!-- Header moderne -->
    <div class="d-flex justify-content-between align-items-center mb-4 header-clinique flex-wrap">
      <div class="d-flex align-items-center gap-3">
        <i class="bi bi-person-circle fs-2 text-primary"></i>
        <h2 class="fw-bold mb-0">Mon compte</h2>
      </div>
      <!--<button class="btn btn-primary btn-lg shadow-sm btn-clinique mt-2 mt-md-0" @click="logout">
        <i class="bi bi-box-arrow-right me-1"></i> Déconnexion
      </button>-->
    </div>

    <!-- Informations utilisateur -->
    <div class="card p-4 shadow-sm rounded card-clinique mb-4">
      <h5 class="fw-bold text-primary mb-3">Informations personnelles</h5>
      <div v-if="user">
        <div class="row mb-2">
          <div class="col-md-4 fw-semibold">Nom complet :</div>
          <div class="col-md-8">{{ user.nom }} {{ user.prenom }}</div>
        </div>

        <div class="row mb-2">
          <div class="col-md-4 fw-semibold">Email :</div>
          <div class="col-md-8">{{ user.email }}</div>
        </div>

        <div class="row mb-2">
          <div class="col-md-4 fw-semibold">Type d’utilisateur :</div>
          <div class="col-md-8">{{ user.typeUser || 'Non défini' }}</div>
        </div>

        <div class="row mb-2">
          <div class="col-md-4 fw-semibold">Date de création :</div>
          <div class="col-md-8">{{ formatDate(user.createdAt.date) }}</div>
        </div>
      </div>
      <div v-else class="text-muted fst-italic">Aucune information disponible</div>
    </div>

    <!-- Changement de mot de passe -->
    <div class="card p-4 shadow-sm rounded card-clinique">
      <h5 class="fw-bold text-primary mb-3">Changer le mot de passe</h5>

      <form @submit.prevent="updatePassword">
        <div class="row g-3">
           <div class="col-md-4">
  <label class="form-label fw-semibold">Mot de passe actuel</label>

  <div class="input-group">
    <input
      v-model="currentPassword"
      :type="showCurrent ? 'text' : 'password'"
      class="form-control form-control-clinique"
      placeholder="Mot de passe actuel"
      required
    />

    <button type="button" class="btn btn-outline-secondary" @click="showCurrent = !showCurrent">
      <i :class="showCurrent ? 'bi bi-eye-slash' : 'bi bi-eye'"></i>
    </button>
  </div>
</div>

         <div class="col-md-4">
  <label class="form-label fw-semibold">Nouveau mot de passe</label>

  <div class="input-group">
    <input
      v-model="newPassword"
      :type="showNew ? 'text' : 'password'"
      class="form-control form-control-clinique"
      placeholder="Nouveau mot de passe"
      required
    />

    <button type="button" class="btn btn-outline-secondary" @click="showNew = !showNew">
      <i :class="showNew ? 'bi bi-eye-slash' : 'bi bi-eye'"></i>
    </button>
  </div>
</div>
<div class="col-md-4">
  <label class="form-label fw-semibold">Confirmer le nouveau mot de passe</label>

  <div class="input-group">
    <input
      v-model="confirmPassword"
      :type="showConfirm ? 'text' : 'password'"
      class="form-control form-control-clinique"
      placeholder="Confirmer mot de passe"
      required
    />

    <button type="button" class="btn btn-outline-secondary" @click="showConfirm = !showConfirm">
      <i :class="showConfirm ? 'bi bi-eye-slash' : 'bi bi-eye'"></i>
    </button>
  </div>
</div>
        </div>

        <div class="mt-4">
          <button type="submit" class="btn btn-primary btn-clinique shadow-sm" :disabled="loading">
            <span v-if="loading" class="spinner-border spinner-border-sm me-2"></span>
            Mettre à jour
          </button>
        </div>

        <div v-if="message" class="alert mt-3" :class="messageType">{{ message }}</div>
      </form>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import dayjs from 'dayjs';
import apiClient from '@/api';
import api from '@/api';

export default {
  name: 'MonCompte',
  data() {
    return {
        currentPassword: '',
    newPassword: '',
    confirmPassword: '',
    
    showCurrent: false,
    showNew: false,
    showConfirm: false,

    message: '',
    messageType: 'alert-info',
    loading: false,
    };
  },
  computed: {
    ...mapGetters(['user']),
  },
  methods: {
    ...mapActions(['logout']),
    formatDate(date) {
      if (!date) return 'N/A';
      return dayjs(date).format('DD-MM-YYYY HH:mm');
    },
    async updatePassword() {
      if (this.newPassword !== this.confirmPassword) {
        this.message = "Les mots de passe ne correspondent pas.";
        this.messageType = 'alert-danger';
        return;
      }

     

      this.loading = true;
      this.message = '';
      if (!this.currentPassword || !this.newPassword || !this.confirmPassword) {
  this.message = "Tous les champs sont obligatoires.";
  this.messageType = "alert-danger";
  return;
}

if (this.newPassword.length < 6) {
  this.message = "Le mot de passe doit contenir au moins 6 caractères.";
  this.messageType = "alert-danger";
  return;
}

      try {
await api.updatePassword({
  id: this.user.id,
  currentPassword: this.currentPassword,
  newPassword: this.newPassword
});

  this.message = 'Mot de passe mis à jour avec succès.';
  this.messageType = 'alert-success';
  this.currentPassword = this.newPassword = this.confirmPassword = '';
} catch (error) {
  this.message = error.response?.data?.error || "Une erreur est survenue.";
  this.messageType = 'alert-danger';
} finally {
  this.loading = false;
}
    },
  },
};
</script>

<style scoped>
.header-clinique {
  border-bottom: 2px solid #f0f0f0;
}

.card-clinique {
  border-radius: 1rem;
  background: #fff;
}

.form-control-clinique {
  border-radius: 0.5rem;
  border: 1px solid #ddd;
}

.btn-clinique {
  border-radius: 0.6rem;
  font-weight: 600;
}

.alert {
  border-radius: 0.75rem;
}
</style>
